import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { UserXIcon, ClockIcon, CameraOffIcon, AlertTriangleIcon } from 'lucide-react';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const problems = [{
    icon: UserXIcon,
    title: 'The Influencer Barrier',
    description: 'Fear of being the center of attention. Not everyone wants to be a "personality" or deal with public scrutiny.'
  }, {
    icon: ClockIcon,
    title: 'The Production Trap',
    description: '20+ hours per week editing, scripting, filming. Your side hustle becomes a second full-time job.'
  }, {
    icon: CameraOffIcon,
    title: 'The Gear Myth',
    description: 'Expensive cameras, lighting, microphones. Thousands spent before making your first dollar.'
  }, {
    icon: AlertTriangleIcon,
    title: 'The Burnout Cycle',
    description: 'Constant content demands. Miss a week and your algorithm ranking tanks. No breaks allowed.'
  }];
  return <section ref={ref} className="relative w-full py-24 md:py-32 px-4 bg-bg-primary" data-id="element-223">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,_rgba(0,255,136,0.03)_0%,_transparent_50%)] pointer-events-none" data-id="element-224" />

      <div className="relative max-w-6xl mx-auto" data-id="element-225">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-226">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-227">
            The <span className="text-red-500" data-id="element-228">Problem</span> With Traditional
            YouTube
          </h2>
          <p className="text-text-muted text-lg max-w-2xl mx-auto" data-id="element-229">
            The old playbook is broken. Here's why most people never make it.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-230">
          {problems.map((problem, index) => <motion.div key={problem.title} initial={{
          opacity: 0,
          y: 30
        }} animate={isInView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="glass-card rounded-xl p-6 md:p-8 group" data-id="element-231">
              <div className="flex items-start gap-4" data-id="element-232">
                <div className="flex-shrink-0 w-12 h-12 rounded-lg bg-red-500/10 flex items-center justify-center" data-id="element-233">
                  <problem.icon className="w-6 h-6 text-red-500" data-id="element-234" />
                </div>
                <div data-id="element-235">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-236">
                    {problem.title}
                  </h3>
                  <p className="text-text-muted leading-relaxed" data-id="element-237">
                    {problem.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}